module.exports = __webpack_public_path__ + "img/news.d8647e59.png";